function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_x0020_1"
}, /*#__PURE__*/React.createElement("metadata", {
  id: "CorelCorpID_0Corel-Layer"
}), /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  d: "M368.88 615.908l1310.24 0c31.0725,0 59.2985,12.6957 79.7398,33.137 20.4473,20.4473 33.1406,48.6804 33.1406,79.7434l0 461.018c0,31.063 -12.698,59.2926 -33.1441,79.7363 -18.9626,18.965 -44.6244,31.2614 -73.0323,32.9433 0.453544,-5.17087 0.686221,-10.3843 0.686221,-15.6248 0,-47.1355 -18.5882,-91.9961 -51.913,-125.32 -33.3236,-33.3236 -78.1831,-51.9119 -125.319,-51.9119 -47.1343,0 -91.9961,18.5894 -125.32,51.9119 -33.3225,33.3236 -51.9119,78.1855 -51.9119,125.32 0,5.30906 0.238583,10.5886 0.703938,15.8256l-617.503 0c0.465355,-5.23701 0.703938,-10.5165 0.703938,-15.8256 0,-47.1343 -18.5894,-91.9961 -51.9119,-125.32 -33.3236,-33.3225 -78.1855,-51.9119 -125.32,-51.9119 -47.1355,0 -91.995,18.5882 -125.319,51.9119 -21.6803,21.6792 -37.1209,48.2433 -45.2658,77.1379 -0.375591,1.33228 -0.735827,2.67047 -1.07953,4.01221 -3.66851,14.2902 -5.56772,29.113 -5.56772,44.1697 0,5.24056 0.232677,10.4539 0.686221,15.6248 -28.4079,-1.68189 -54.0721,-13.9736 -73.0382,-32.9398 -20.4414,-20.4414 -33.137,-48.6674 -33.137,-79.7398l0 -461.018c0,-31.076 12.6898,-59.3044 33.1335,-79.7469 20.4425,-20.4437 48.6709,-33.1335 79.7469,-33.1335zm1359.12 525.019l0 -64.0016 -84.6698 0c-17.6728,0 -32.0008,14.328 -32.0008,32.0008 0,17.6728 14.328,32.0008 32.0008,32.0008l84.6698 0zm0 -141.911l0 -270.228 -1408 0 0 270.228 1408 0z"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  points: "288,721.046 1760,721.046 1760,785.047 288,785.047 "
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  points: "288,947.514 1760,947.514 1760,1011.52 288,1011.52 "
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  points: "515.981,753.047 515.981,979.515 451.98,979.515 451.98,753.047 "
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  points: "708.223,753.047 708.223,979.515 644.221,979.515 644.221,753.047 "
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  points: "900.463,753.047 900.463,979.515 836.461,979.515 836.461,753.047 "
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  points: "1092.7,753.047 1092.7,979.515 1028.7,979.515 1028.7,753.047 "
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  points: "1284.94,753.047 1284.94,979.515 1220.94,979.515 1220.94,753.047 "
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  points: "1477.19,753.047 1477.19,979.515 1413.18,979.515 1413.18,753.047 "
}), /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  d: "M1509.28 1141.63c40.1008,0 76.4091,16.2579 102.692,42.5398 26.2831,26.2831 42.5398,62.5926 42.5398,102.692 0,40.1008 -16.2567,76.4091 -42.5398,102.692 -26.2831,26.2831 -62.5914,42.5398 -102.692,42.5398 -40.1008,0 -76.4091,-16.2567 -102.692,-42.5398 -26.2831,-26.2831 -42.5398,-62.5914 -42.5398,-102.692 0,-40.0985 16.2579,-76.4091 42.5398,-102.692 26.2831,-26.2819 62.5937,-42.5398 102.692,-42.5398z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  d: "M538.72 1141.63c40.0985,0 76.4091,16.2579 102.692,42.5398 26.2819,26.2831 42.5398,62.5937 42.5398,102.692 0,40.1008 -16.2567,76.4091 -42.5398,102.692 -26.2831,26.2831 -62.5914,42.5398 -102.692,42.5398 -40.1008,0 -76.4091,-16.2567 -102.692,-42.5398 -26.2831,-26.2831 -42.5398,-62.5914 -42.5398,-102.692 0,-40.0996 16.2567,-76.4091 42.5398,-102.692 26.2831,-26.2819 62.5914,-42.5398 102.692,-42.5398z"
}));

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  fill: "current",
  stroke: "current",
  strokeWidth: 2,
  width: 2048,
  height: 2048
});

var SvgBus3 = function SvgBus3(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlSpace: "preserve",
    width: "2048px",
    height: "2048px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 2048 2048",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBus3, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Bus3.f6652434.svg";
export { ForwardRef as ReactComponent };